import { withPrefix } from "gatsby";
import styled from "styled-components";
import Modal from "../modals";

export const LoginModalWrapper = styled.div`
  color: black;
  margin: auto;
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 415px 600px;
  background: white;
  max-width: 1241px;
  height: 875px;
  h2.help {
    color: #000;
  }
  .brandingReg {
    background-image: url(${() => withPrefix(`images/LoginLogo.png`)}),
      url(${() => withPrefix(`images/RegistrationBG.png`)});
    background-color: #000000;
    background-repeat: no-repeat;
    background-size: 100% 100% !important;
    color: white;
    padding: 210px 0px 0px 30px;
    font-size: 34px;
    font-family: var(--main-font);
    text-transform: uppercase;
    span {
      letter-spacing: 7.5px;
    }
    a.assistance {
      text-decoration: none;
    }
    a.assistance h2 {
      color: #7f35b2;
      font-size: 22px;
      text-transform: none;
      font-family: var(--main-font);
      margin-top: 510px;
    }
  }

  .divider {
    display: grid;
    grid-template-columns: 14px 1fr 5px 100px 5px 1fr 18px;
    justify-content: center;
    align-items: center;
    margin-top: 15px;

    h2 {
      text-align: center;
      margin: 10px 0px;
    }

    .circle,
    .line {
      color: #7f35b2;
    }

    .circle {
      width: 10px;
      height: 10px;
      border: 4px solid;
      border-radius: 100px;
    }

    .line {
      border-top: 4px solid;
      height: 1px;
    }

    .line.vertical.left {
      border-left: 4px solid;
      border-right: none;
    }

    .line.vertical {
      width: 1px;
      height: 10px;
      border: none;
      border-right: 4px solid;
    }
  }

  section {
    overflow-x: hidden;
    padding: 30px 55px 0;

    h2 {
      font-family: var(--main-font);
      font-weight: 900;
      font-size: 26px;
      line-height: 31px;
      color: #000000;

      span {
        font-weight: 100;
        font-family: "RedHatDisplay-Black", sans-serif;
      }
    }

    .form-register form {
      margin-top: 15px;
      grid-gap: 20px;
    }
    .dotLine {
      border-bottom: 1px dotted #979797;
    }
    p.lg.info.italic.smaller {
      line-height: 1;
    }
    .charity {
      font-size: 16px;
      font-family: "RedHatText-Medium", sans-serif;
      font-weight: 500;
      color: #000;
    }
    .cblack label {
      color: #000;
    }

    .form-login form .input-wrapper input,
    .form-register form .field input {
      font-size: 16px !important;
      height: 50px !important;
      padding: 0px 0px 0px 10px;
    }

    .form-register form .footer.submit input,
    .form-login form .submit input {
      font-size: 20px;
      height: 50px;
      background-image: linear-gradient(to left, #7f35b2, #7f35b2, #7f35b2);
      /*background-color: #7f35b2;*/
      background-size: 200%;
      transition: 0.6s;
    }
    .form-login form .submit input:hover,
    .form-register form .footer.submit input:hover {
      background-color: #000;
    }
    .form-register form .footer.submit {
      grid-column: 2/3 !important;
      width: 200px;
      justify-self: end;
    }

    .assistance {
      text-decoration: none;
    }

    .assistance.footer {
      /* display: none; */
    }
  }

  @media only screen and (max-width: 550px) {
    .brandingReg {
      background-size: 403px;

      span {
        margin-right: 187px !important;
      }
    }
  }

  @media only screen and (max-width: 420px) {
    .brandingReg {
      background-size: 90%;
    }
    .brandingReg span {
      margin-right: 0px !important;
      width: 100%;
    }
  }

  @media only screen and (min-width: 766px) and (max-width: 1075px) {
    grid-template-columns: 320px 425px;

    .brandingReg {
      background-size: 82%;
      padding: 195px 0px 0px 0px;
      text-align: center;
      font-size: 30px;
    }

    section {
      max-width: 95% !important;
      margin: 0 auto !important;
      padding: 10px 20px 20px !important;
    }
  }

  @media only screen and (min-width: 766px) and (max-width: 785px) {
    grid-template-columns: calc(0.75 * 320px) calc(0.75 * 425px);
  }

  @media only screen and (min-width: 120px) and (max-width: 766px) {
    display: block;
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    p.info,
    .dotLine {
      margin-bottom: 20px;
    }
    .cblack {
      display: grid;
      grid-template-columns: 1fr;
    }
    .cblack div {
      display: grid;
      grid-template-columns: 3fr 1fr;
      margin-bottom: 20px;
    }
    .brandingReg {
      padding: 0 !important;
      height: 88vw !important;
      background-image: url(${() => withPrefix(`images/MobileLogo.png`)});
      background-color: #fff !important;
      background-repeat: no-repeat !important;
      background-size: 420px;
      background-position: center 51px;
      color: white;
      font-size: 20px;
      text-transform: uppercase;
      font-family: var(--main-font);
      justify-content: center;
      position: relative;
      display: flex;

      span {
        margin-right: 242px; // 312
        letter-spacing: 7.5px;
      }

      .assistance {
        display: none;
      }
    }

    section {
      padding: 0px 20px;

      .divider {
        grid-template-columns: 14px 1fr 5px 65px 5px 1fr 18px;
      }

      .divider h2 {
        padding: 5px 0px 5px 0px !important;
        margin: 0px;
      }

      h2 {
        padding: 30px 0px 15px 0px !important;
        margin: 0px;
        font-size: 20px;
      }

      .form-register form .industry {
        margin: 15px 0px 5px;

        label {
          color: #646464;
        }
      }

      .form-register form .field {
        margin-bottom: 20px;
      }

      .form-register form .info,
      .form-register form .info.consent {
        font-family: var(--main-font);
        color: #646464;
      }

      .form-register form .info {
        font-size: 12px;
      }

      .form-register form .info.consent {
        // font-size: 12px;
        margin-bottom: 15px;
        display: flex;
        justify-content: start;
        align-items: center;
      }

      .form-register form .info.consent:first-child {
        margin-bottom: 15px !important;
      }

      .form-register form .footer.submit {
        grid-column: 1/3 !important;
        width: 100%;
        font-family: var(--main-font);
        font-size: 20px;
        padding-top: 5px !important;
      }

      .assistance.footer {
        display: block;
        margin: 20px 0px 80px 0px;
      }
      .charity {
        font-size: 16px;
        font-family: "RedHatText-Medium", sans-serif !important;
        font-weight: 500;
        color: #000 !important;
      }
      .cblack {
        color: #000 !important;
      }
    }
  }
`;

export const StyledLoginModal = styled(Modal)`
  background-color: #ffffffe3;

  .content {
    margin: 0px 30px;
  }

  @media only screen and (min-width: 766px) and (max-width: 1000px) {
    .content {
      margin: 0px !important;
    }
  }

  @media only screen and (min-width: 320px) and (max-width: 766px) {
    .content {
      margin: 0px !important;
    }
  }

  @media only screen and (max-width: 766px) {
    .content {
      margin: 0px !important;
    }
  }
`;

export const StyledGatedModal = styled(StyledLoginModal)`
  width: 100%;

  .container {
    background-color: #fff !important;
    padding: 15px 25px 25px;
    max-width: 400px;
    width: 100%;
    color: rgba(5, 21, 38, 1);
  }

  h2 {
    font-size: 16px;
    font-weight: 600;
    color: hsl(218.05714285714285, 96.68508287292819%, 62.50980392156863%);
  }

  p {
    font-size: 20px;
    font-weight: 400;
  }

  button {
    font-family: var(--main-font);
    font-weight: 600;
    font-size: 24px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 1px;
    padding: 7px 15px;
    background: transparent;
    border: 2px solid rgba(5, 21, 38, 1);
    cursor: pointer;
    transition: all 250ms ease;
    margin-top: 10px;

    &:hover {
      color: #fff;
      background: rgba(5, 21, 38, 1);
    }
  }

  @media screen and (max-width: 525px) {
    .container {
      max-width: 80vw;
    }
  }
`;
